import React from "react";
import { Link } from "react-router-dom";

/** Brand mark Amazonico 3000 — editorial double-border with letter A in Times Italic.
 * Sizes: sm (32px), md (44px), lg (60px). Variants: dark (default, on light bg)
 * or light (on dark bg). Use compact={true} to hide the wordmark.
 */
export default function BrandMark({ size = "md", variant = "dark", compact = false, linked = true, className = "" }) {
  const dims = { sm: 32, md: 44, lg: 60, xl: 80 };
  const fonts = { sm: 16, md: 22, lg: 30, xl: 40 };
  const px = dims[size] || dims.md;
  const fz = fonts[size] || fonts.md;

  const goldOuter = "#C9A961";
  const goldInner = variant === "light" ? "#E2A03F" : "#A88A4A";
  const letterColor = variant === "light" ? "#C9A961" : "#1a0608";
  const textColor = variant === "light" ? "text-white" : "text-[#0a0a0a]";
  const subColor = variant === "light" ? "text-[#C9A961]" : "text-[#A88A4A]";

  const Mark = (
    <div className={`inline-flex items-center gap-3 ${className}`}>
      <span
        aria-label="Amazonico 3000 logo"
        className="relative shrink-0 inline-flex items-center justify-center"
        style={{ width: px, height: px }}
      >
        {/* Outer gold square */}
        <span
          className="absolute inset-0"
          style={{ border: `1px solid ${goldOuter}` }}
        />
        {/* Inner thin gold square */}
        <span
          className="absolute"
          style={{
            top: 3, left: 3, right: 3, bottom: 3,
            border: `0.5px solid ${goldInner}`,
          }}
        />
        {/* Letter A */}
        <span
          style={{
            color: letterColor,
            fontFamily: '"Times New Roman", Times, Georgia, serif',
            fontStyle: "italic",
            fontWeight: 400,
            fontSize: fz,
            lineHeight: 1,
            position: "relative",
            top: -1,
          }}
        >A</span>
      </span>
      {!compact && (
        <span className="leading-tight">
          <span className={`block text-[10px] uppercase tracking-[0.32em] font-bold ${textColor}`}>
            Amazonico 3000
          </span>
          <span className={`block text-[9px] uppercase tracking-[0.22em] ${subColor} mt-0.5`}>
            Gestionale B2B · Italia → Brasile
          </span>
        </span>
      )}
    </div>
  );

  return linked ? <Link to="/gestionale/dashboard">{Mark}</Link> : Mark;
}
